import { createContext } from 'react';
import { IOrganizationAllLicenseItem } from '../models/IOrganizationAllLicenseItem';

export interface IOrganizationAllLicensesContext {
  licenses: IOrganizationAllLicenseItem[] | null;
  onRefresh: () => Promise<any>;
}

export const OrganizationAllLicensesContext = createContext<IOrganizationAllLicensesContext>({
  licenses: null,
  onRefresh: () => Promise.resolve(null),
});
